<template>
  <div id="map" class="map" />
</template>

<script>
import { default as Map } from '../plugins/new_map';
import { Tile as TileLayer } from 'ol/layer';
import { XYZ } from 'ol/source';

import installCrs from '@/mixins/map/crs';
import view from '@/mixins/map/view';

export default {
  name: 'AdminSettingsMap',
  mixins: [installCrs, view],
  data: () => ({
    map: undefined,
  }),
  props: {
    emitView: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    center() {
      this.map.getView().setCenter(this.center);
    },
    zoom() {
      this.map.getView().setZoom(this.zoom);
    },
  },
  methods: {
    initMap() {
      this.map = new Map({
        maxTilesLoading: 128,
        keyboardEventTarget: document,
        layers: [
          new TileLayer({
            source: new XYZ({
              url: `${process.env.VUE_APP_OSM_URL}/{z}/{x}/{y}.png`,
            }),
            name: 'OSM',
          }),
        ],
        target: 'map',
        view: this.prepareView(),
      });
      if (this.emitView) {
        this.map.on('moveend', e => {
          const { map } = e;
          const zoom = map.getView().getZoom();
          const center = map.getView().getCenter();
          this.$store.set('map/SET_CENTER!', center);
          this.$store.set('map/SET_ZOOM!', zoom);
          this.$emit('viewChanged', { zoom, center });
        });
      }
    },
    beforeDestroy() {
      this.map.setTarget(null);
      this.map = null;
      this.$off();
    },
  },
  mounted() {
    this.initMap();
    this.$once('hook:beforeDestroy', this.beforeDestroy);
  },
};
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: 25vh;
  @include border(all, 1px, #898989);
  border-radius: 5px;
}
::v-deep .ol-viewport {
  border-radius: inherit;
}
</style>
